/* eslint react/jsx-props-no-spreading: 0 */
import {
    Card as MUICard,
    CardProps as MUICardProps,
    CardHeader,
    CardHeaderProps as MUICardHeaderProps,
    CardContent,
    CardContentProps as MUICardContentProps,
    CardMedia,
    CardMediaProps as MUICardMediaProps,
    CardActions,
    CardActionsProps as MUICardActionsProps,
} from '@mui/material';
import { ReactNode } from 'react';

type CardProps = {
    rootProps?: MUICardProps & {
        'data-testid'?: string;
    };
    children?: ReactNode | ((props: { media: ReactNode; content: ReactNode }) => ReactNode);
    headerProps?: MUICardHeaderProps;
    content?: ReactNode;
    contentProps?: MUICardContentProps;
    mediaProps?: MUICardMediaProps<'img' | 'iframe'>;
    actions?: ReactNode;
    actionsProps?: MUICardActionsProps;
};

export function Card({
    rootProps,
    children,
    headerProps,
    content,
    contentProps,
    mediaProps,
    actions,
    actionsProps,
}: CardProps) {
    const childrenIsFunction = typeof children === 'function';

    const mediaElement = mediaProps ? <CardMedia {...mediaProps} /> : null;

    const contentElement = content != null ? <CardContent {...contentProps}>{content}</CardContent> : null;

    return (
        <MUICard {...rootProps}>
            {headerProps != null && <CardHeader {...headerProps} />}
            {childrenIsFunction ? (
                children({ media: mediaElement, content: contentElement })
            ) : (
                <>
                    {mediaElement}
                    {contentElement}
                    {children != null && children}
                </>
            )}
            {actions != null && <CardActions {...actionsProps}>{actions}</CardActions>}
        </MUICard>
    );
}
